import { IconName } from '@frontend/icons';
import { Text, useTooltip } from '@frontend/design-system';
import { FilterMenuButton } from './FilterMenuButton';

export const DisabledSection = ({
  label,
  tooltip,
  iconName,
}: {
  label: string;
  tooltip?: string;
  iconName: IconName;
}) => {
  const { triggerProps, tooltipProps, Tooltip } = useTooltip({ placement: 'bottom' });

  return (
    <div {...triggerProps} aria-label={tooltip} aria-disabled>
      <Tooltip {...tooltipProps}>
        <Text css={{ margin: 0 }} color='white'>
          {tooltip}
        </Text>
      </Tooltip>
      <FilterMenuButton menuName={label} iconName={iconName} disabled={true} />
    </div>
  );
};
